export default __webpack_public_path__ + "static/soehne-web-fett-kursiv-cdbf31594d3fba4bc0b6cb4ce86a4ee4.woff";